import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'qs';
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HOME_PATH } from '../../../constant/Constant';
import PopupRef from '../../../component/PopupRef';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { actionPasswordReset } from '../../../module/body/main/PasswordResetModule';
import ConfirmButtonBox from '../../../component/buttons/ConfirmButtonBox';
import PasswordInputBox from '../../../component/PasswordInputBox';

const PasswordReset = () => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const [id, setId] = useState(queryData.userId);
    const [uid, setUid] = useState(queryData.uid);

    const [password, setPassword] = useState('');
    const [isPassword, setIsPassword] = useState(false);
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [isPasswordConfirm, setIsPasswordConfirm] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    const { result } = useSelector((state) => state.passwordResetState);

    useEffect(() => {
        {
            !uid &&
                popupRef.current.openAlert('URL을 통한 접근 시 메인페이지로 이동 합니다.', () => {
                    return function () {
                        navigate(HOME_PATH);
                    };
                });
        }
    }, []);

    const inputValidation = () => {
        if (NullCheckUtil.isEmpty(password) || !isPassword) {
            popupRef.current.openAlert('화면의 비밀번호 오류메시지를 확인 해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(passwordConfirm) || !isPasswordConfirm) {
            popupRef.current.openAlert('비밀번호 확인란을 확인 해주세요.');
            return false;
        } else if (password != passwordConfirm) {
            popupRef.current.openAlert('비밀번호가 일치하지 않습니다. 다시 입력해 주세요.');
            return false;
        } else {
            return true;
        }
    };

    const handleConfirm = () => {
        if (inputValidation()) {
            dispatch(
                actionPasswordReset({
                    data: {
                        userId: id,
                        uid,
                        pswd: btoa(password),
                    },
                    callback: () => {
                        popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                            return function () {
                                navigate(HOME_PATH);
                            };
                        });
                    },
                }),
            );
        }
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='user-wrap'>
                    <div className='find-info-top'>
                        <h2 className='find-info-tit'>비밀번호 재설정</h2>
                    </div>
                    <div className='resetPw-content'>
                        <div className='resetPw-comment'>
                            <ul className='explain-txt'>
                                <li>비밀번호를 변경해 주세요.</li>
                                <li>다른 아이디나 사이트에서 사용한 적 없는 안전한 비밀번호로 변경해 주세요</li>
                                <li>영문, 숫자, 특수문자를 함께 사용하여 8자 이상으로 사용하세요.</li>
                            </ul>
                        </div>
                        <div className='resetPw-form-wrap'>
                            <div className='user-id-box'>
                                <div className='id-label'>아이디</div>
                                <div className='id-data'>{id}</div>
                            </div>
                            <PasswordInputBox
                                setPassword={setPassword}
                                setIsPassword={setIsPassword}
                                setPasswordConfirm={setPasswordConfirm}
                                setIsPasswordConfirm={setIsPasswordConfirm}
                            />
                        </div>
                        {/* TODO : 캡차 처리 등 */}
                        {/* <div className='secure-check'>
                            <p>아래 이미지를 보이는대로 입력해주세요</p>
                            <div className='secure-img-box'></div>
                            <div className='secure-ipt input-box'>
                                <div className='input-group'>
                                    <input type='text' className='form-control' placeholder='자동입력 방지문자' />
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className='cmnty-btn-box btn-wrap'>
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm(e)} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default PasswordReset;
